import { mapValues } from 'lodash-es';
import type { PassengersData } from '@aviata/booking-data';

// No `g` flag: a global regex is stateful across `.test()` calls
// (`lastIndex` advances and is never reset), so reusing a module-level
// `/[- ]/g` here makes `checkSpecialSymbolsInInitials` alternate true/false
// on repeated calls for the same name — which silently let a dashed name
// slip past the check on every other submit/save. `.test()` only needs to
// know whether a match exists, so the non-global form is both correct and
// stateless.
const specialSymbolsRegex = /[- ]/;

export const checkSpecialSymbolsInInitials = (
  passengersState: PassengersData,
) => {
  return Object.values(passengersState).some(pax => {
    return (
      specialSymbolsRegex.test(pax.firstName) ||
      specialSymbolsRegex.test(pax.lastName)
    );
  });
};

export const removeSpecialSymbolsFromInitials = (
  passengersState: PassengersData,
) => {
  return mapValues(passengersState, pax => {
    return {
      ...pax,
      firstName: pax.firstName.replace(/[- ]/g, ''),
      lastName: pax.lastName.replace(/[- ]/g, ''),
    };
  });
};
